/**
 * «Borrar mi cuenta»: pide a soporte que borre la cuenta del usuario de la sesión (comparsa#825).
 * Aquí no se borra nada; soporte lo tramita a mano. Responde si la petición ha llegado.
 */
const requestAccountDeletion = async (token: string): Promise<boolean> => {
	try {
		const response = await fetch(
			`${process.env.REACT_APP_BASE_API}/users/me/account-deletion-request`,
			{
				method: 'POST',
				headers: { Authorization: `Bearer ${token}` }
			}
		);
		if (!response.ok) {
			return false;
		}
		const respuesta = await response.json();

		return respuesta?.success !== false;
	} catch {
		return false;
	}
};

export default requestAccountDeletion;
